import React from "react";
import { DiseaseDetail } from "../../../../../domain/disease_knowledge/DiseaseDetail";
import { DiseaseMenuSection, diseaseMenuSectionId } from "./DiseaseMenuSection";
import { ItemContents } from "./ItemContents";

export const DetailContentWatch = React.memo(function DetailContentWatch(props: Props) {
    const {
        disease,
        watchRef
    } = props;
    return (
        <>
            <h3 className={"itemName"} id={diseaseMenuSectionId(DiseaseMenuSection.WATCH)} ref={watchRef}>
                日常生活の注意点
            </h3>
            <h4 className={"subItemName"}>【服薬に関して】</h4>
            <ItemContents itemContents={disease.watch.medicines} />
            <h4 className={"subItemName"}>【食事に関して】</h4>
            <ItemContents itemContents={disease.watch.meals} />
            <h4 className={"subItemName"}>【生活・環境に関して】</h4>
            <ItemContents itemContents={disease.watch.lifestyleAndEnvironments} />
            <h4 className={"subItemName"}>【介護者側が注意すべきことに関して】</h4>
            <ItemContents itemContents={disease.watch.carestaffs} />
            <h4 className={"subItemName"}>【その他】</h4>
            <ItemContents itemContents={disease.watch.others} />
        </>
    );
});

type Props = {
    disease: DiseaseDetail
    watchRef: React.RefObject<HTMLHeadingElement>
};